import {
  MediaDetailMetric,
  MediaDetailMetrics,
} from "src/components/media-detail";
import type { EntityHeader } from "src/pages/ad-studio/insights/performance/types";

export const EntityTiles = ({ tiles }: { tiles: EntityHeader["tiles"] }) => (
  <MediaDetailMetrics>
    {tiles.map((tile) => (
      <MediaDetailMetric key={tile.key} label={tile.label} value={tile.value} />
    ))}
  </MediaDetailMetrics>
);
